/**
 * Extracts mentioned user IDs from HTML content containing mention elements
 * @param html - The HTML string containing mentions
 * @returns Array of unique user IDs that were mentioned
 */
export function extractMentionedUserIds(html: string): string[] {
  if (!html) return [];

  // Create a temporary div to parse HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  // Find all mention spans with data-id attribute
  const mentionElements = tempDiv.querySelectorAll('span[data-type="mention"][data-id]');

  // Extract unique IDs
  const userIds = Array.from(mentionElements)
    .map((el) => el.getAttribute('data-id'))
    .filter((id): id is string => !!id);

  // Return unique IDs only
  return [...new Set(userIds)];
}
